import { Organization } from "../../models/organization-field";

export interface OrganizationState {
    organizationList: Organization[];
    loading: boolean;
    error: string | null;
  }
  
  export const initialState: OrganizationState = {
    organizationList: [],
    loading: false,
    error: null,
  };